var formStylingBlock = {
    $formStylingBlock: $('.form-styling-block'),

    init: function() {
        var _this = this;

        _this.$input = _this.$formStylingBlock.find('input:not(input[type=file])');
        _this.$textarea = _this.$formStylingBlock.find('textarea');
        _this.$uploadBtn = _this.$formStylingBlock.find('.upload-btn');
        _this.$fileUploadInput = _this.$formStylingBlock.find('input.file-upload-input');
        _this.$fileUploadText = _this.$formStylingBlock.find('.file-upload-text');
        _this.$numberMin = _this.$formStylingBlock
            .find('input[type=number]')
            .parent()
            .find('.btn-min');
        _this.$numberPlus = _this.$formStylingBlock
            .find('input[type=number]')
            .parent()
            .find('.btn-plus');
        _this.$numberInput = _this.$formStylingBlock.find('input[type=number]');
        _this.$discount = _this.$formStylingBlock.find('.discount-btn');
        _this.$applyDiscount = _this.$formStylingBlock.find('.apply-discount-btn');
        _this.$removeDiscount = _this.$formStylingBlock.find('.remove-discount-btn');
        _this.$createPassword = _this.$formStylingBlock.find('.create-password');
        _this.$createPasswordInput = _this.$formStylingBlock.find('.create-password-input');
        _this.$select2 = _this.$formStylingBlock.find('.select2');

        _this.$noAccountEmail = _this.$formStylingBlock.find('.no-account-email-input');

        _this.listener();
    },

    listener: function() {
        var _this = this;

        this.checkFilledDiscount();
        this.checkFilledInputs();

        if (_this.$select2.length !== 0) {
            _this.$select2.select2({
                minimumResultsForSearch: Infinity
            });
        }

        _this.$input.on('focus', function() {
            $(this)
                .parents('.input-wrapper')
                .addClass('active');
        });

        $('.btn-min').on('click', function() {
            _this.decrementNumber($(this));
        });

        _this.$numberPlus.on('click', function() {
            _this.incrementNumber($(this));
        });

        _this.$numberInput.on('change', function() {
            _this.checkNumber($(this));
        });

        $('.discount-btn').on('click', function(e) {
            _this.changeDiscount($(this));
        });

        _this.$applyDiscount.on('click', function(e) {
            _this.applyDiscount($(this));
        });

        _this.$removeDiscount.on('click', function(e) {
            _this.removeDiscount($(this));
        });

        _this.$createPassword.on('click', function() {
            _this.showPasswordBox($(this));
        });

        _this.$input.on('blur', function() {
            if ($(this).val().length === 0) {
                $(this)
                    .parents('.input-wrapper')
                    .removeClass('active');
            }
        });

        _this.$textarea.on('focus', function() {
            $(this)
                .parents('.input-wrapper')
                .addClass('active');
        });

        _this.$textarea.on('blur', function() {
            if ($(this).val().length === 0) {
                $(this)
                    .parents('.input-wrapper')
                    .removeClass('active');
            }
        });

        _this.$noAccountEmail.on('blur', function() {
            var href = $('.no-account-email').attr('href');
        });

        _this.$uploadBtn.on('click', function() {
            _this.$fileUploadInput.click();
        });

        $(_this.$fileUploadInput[0]).on('change', function() {
            if ($(this).val() !== '') {
                _this.uploadText($(this));
            } else {
                _this.resetUploadText();
            }
        });
    },

    checkFilledInputs: function() {
        if (this.$input.length !== 0) {
            this.$input.each(function() {
                if ($(this).val().length !== 0) {
                    $(this)
                        .parents('.input-wrapper')
                        .addClass('active');
                }
            });
        }
    },

    uploadText: function(input) {
        var name = $(input[0])
            .val()
            .split(/\\|\//)
            .pop();

        var size = input[0].files[0].size / 1024 / 1024;
        size = size.toFixed(2);

        var uploaderText = `${name} (${size}MB)`;

        this.$fileUploadText.html(uploaderText);
        this.$fileUploadText.addClass('active');
    },

    resetUploadText: function(input) {
        this.$fileUploadText.removeClass('active');
        this.$fileUploadText.html(`Upload CV`);
    },

    incrementNumber: function(plus) {
        var oldNumber = plus
            .parent()
            .find('input[type=number]')
            .val();
        var newNumber = parseFloat(oldNumber) + 1;

        if (oldNumber === '') {
            plus
                .parent()
                .find('input[type=number]')
                .val(1);
        } else {
            plus
                .parent()
                .find('input[type=number]')
                .val(newNumber);
        }

        plus
            .parent()
            .find('input[type=number]')
            .trigger('change');
    },

    decrementNumber: function(min) {
        var oldNumber = min
            .parent()
            .find('input[type=number]')
            .val();
        var newNumber = parseFloat(oldNumber) - 1;

        if (oldNumber === '' || oldNumber <= 1) {
            min
                .parent()
                .find('input[type=number]')
                .val(1);
        } else {
            min
                .parent()
                .find('input[type=number]')
                .val(newNumber);
        }

        min
            .parent()
            .find('input[type=number]')
            .trigger('change');
    },

    checkNumber: function(input) {
        if (input.val() < 1) {
            input.val(1);
        }
    },

    changeDiscount: function(discountBtn) {
        discountBtn
            .parent()
            .find('.input-wrapper')
            .css('display', 'flex');
        discountBtn.css('display', 'none');
    },

    applyDiscount: function(applyBtn) {
        $('.discount-filled').css('display', 'flex');
        applyBtn.parent().css('display', 'none');
    },

    removeDiscount: function(removeBtn) {
        removeBtn.parent().css('display', 'none');
        this.$discount.css('display', 'block');
    },

    showPasswordBox: function(checkbox) {
        if (checkbox.is(':checked')) {
            this.$createPasswordInput.css('display', 'block');
        } else {
            this.$createPasswordInput.css('display', 'none');
        }
    },

    checkFilledDiscount: function() {
        if ($('.discount-filled').length !== 0) {
            if ($('.discount-filled').html().length !== 0) {
                $('.discount-filled').css('display', 'flex');
                $('.discount-line')
                    .find('.field-wrapper')
                    .css('display', 'none');
                $('.discount-btn').css('display', 'none');
            } else {
                $('.discount-btn').css('display', 'block');
                $('.discount-line')
                    .find('.field-wrapper')
                    .css('display', 'none');
                $('.discount-filled').css('display', 'none');
            }
        }
    }
};
